import React from 'react';
import { Navigate } from 'react-router-dom';

type Props = {
  condition: boolean;
  component: React.ReactElement;
};

const ProtectedRoute = ({ condition, component }: Props) => {
  if (!condition) {
    return <Navigate to="/" replace />;
  }

  return component;
};

export default ProtectedRoute;
